import React from 'react'
import RouteConfig from '../routes/RouteConfig';
import DynamicSitemap from 'react-dynamic-sitemap';
export default function Sitemap(props) {
    return (
        <DynamicSitemap routes={RouteConfig} prettify={true} {...props} />
    );
}